import { z } from "zod";

import type { INodeSettings } from "../types/index.ts";
import { PaletteSetting } from "./Palette.ts";
import { Condition } from "./TriggerDesigns.ts";

export const MultilingualSettingValue = z.object({
  __ml: z.record(z.string()),
});

export type MultilingualSettingValue = z.infer<typeof MultilingualSettingValue>;

export type NodeSettingsValue =
  | number
  | boolean
  | string
  | undefined
  | null
  | { [name: string]: NodeSettingsValue }
  | MultilingualSettingValue
  | PaletteSetting
  | NodeSettingsValue[]
  | Condition;

export const NodeSettingsValue: z.ZodType<NodeSettingsValue> = z.union([
  z.number(),
  z.boolean(),
  z.string(),
  z.undefined(),
  z.null(),
  z.lazy(() => z.record(NodeSettingsValue)),
  MultilingualSettingValue,
  PaletteSetting,
  z.lazy(() => NodeSettingsValue.array()),
  Condition,
]);

export const NodeSettings = z.record(NodeSettingsValue) as z.ZodType<INodeSettings>;
